// 返回当前页面所在域名的上报 url
export var getReportUrl = function getReportUrl() {
  return "".concat(window.location.origin, "/eclytics/i");
};